export default __webpack_public_path__ + "static/media/border-header.3162ed4b.svg";